/** Carregamento inicial do shell `/app` (perfil antes de exibir seções). */
export const APP_SHELL_LOADING_MESSAGE = 'Carregando…';

/** Carregamento inicial de uma seção (listas / formulário dependem de fetch). */
export const APP_SECTION_LOADING_MESSAGE = 'Carregando…';

/** Encerrar sessão (dropdown da conta no header). */
export const APP_HEADER_LOGOUT = 'Sair';

/** Estado enquanto o logout está em andamento. */
export const APP_HEADER_LOGGING_OUT = 'Saindo';
